/***************************************************************************************************
 *              This componet displays the paid or pending invoices for the clients                *
 *                                      This is a client page                                      *
 *  CREATED BY: Aniket Atram                                                                       *
 *  Updated ON: 6 April 2023                                                                       *
 *                                                                                                 *
 *  Description of update: Added a conditon to check if the invoice is of cbv3 app or not          *
 *  If the invoice belongs to JobsPikr or Datastock then user is redirected to invoice list page   *
 *  The status code retun for it is 422                                                            *
 **************************************************************************************************/
// React imports
import React from 'react';
import { useState, useEffect, useMemo } from 'react';
import { useHistory, useParams } from 'react-router-dom';

// Third party imports
import { Container, Row, Col, Alert } from 'reactstrap';
import axios from 'axios';
import { toast } from 'react-toastify';
import isEmpty from 'lodash/isEmpty'

// Components and script imports
import SpinnerLoader from '../../../Common/LoadingAnimation/SpinnerLoader.component';
import Breadcrumbs from '../../../Common/BreadCrumb/BreadCrumbs.component';
import SuperUserContext from '../../../Context/Providers/SuperUserPrivilege/SuperUserContext.component';
import PaidInvoice from './PaidInvoice.component';
import PendingInvoice from './PendingInvoice.component';

// custom hooks
import useOrgIdentifer from '@hooks/org_identifier';

export default function InvoiceDetails({ razorpayKey, current_user, current_organization, take_my_org_details }) {

  const [loading, setLoading] = useState(false); // used for displaying the loading animation
  const [invoiceData, setInvoiceData] = useState([]); // used for storing data from DB
  const [toggle, setToggle] = useState(false);

  // Organization name and invoice ID from URL
  const { invoiceId } = useParams();

  const history = useHistory();

  const org_identifier = useOrgIdentifer();

  useEffect(() => {
    take_my_org_details(org_identifier);
  }, [org_identifier]);

  // INVOICE API ENDPOINT
  const INVOICE_API = useMemo(() => `/api/v1/organizations/${org_identifier}/invoices/${invoiceId}?page_type=client&controller_name=invoices`, [org_identifier, invoiceId]);

  // PAYMENT API ENDPOINT
  const PAYMENT_API = useMemo(() => `/api/v1/organizations/${org_identifier}/invoices/${invoiceId}/payments?page_type=client&controller_name=new_payments`, [org_identifier, invoiceId]);

  // Use-effect hook for whenever the user initiates the payment
  useEffect(async () => {

    const controller = new AbortController();
    setLoading(true);
    await fetchInvoiceDataFromDB(INVOICE_API, controller.signal);
    setLoading(false);
    // cleanup
    return () => {
      controller.abort();
    }
  }, [toggle]);


  // Helper function to fetch data from the Database
  async function fetchInvoiceDataFromDB(baseURI, signal) {
    try {
      const response = await axios.get(INVOICE_API, { signal: signal });
      const data = await response?.data?.invoice;
      setInvoiceData(data);
    }
    catch (err) {
      // Refactor later
      if (err?.response?.data?.page_auth_failed) {
        history.push("/")
        toast.error(err?.response?.data?.message)
      }
      else if (!err?.response?.data?.org_auth_failed){
        if(err?.response?.status === 422){
          toast?.error(err?.response?.data?.message);
          history.push(`/organizations/${org_identifier}/invoices`);
        }
        else{
          toast.error(err?.response?.data?.message)
        }
      }
    }
  };


  return (
    <>
      <div className='container-fluid'>
        <SuperUserContext>
          <SpinnerLoader loading={isEmpty(invoiceData) && loading}>
            <Breadcrumbs
              parent={"Invoices"}
              title={`Invoice #${invoiceData?.id}`}
              childrenObj={[{ name: 'Invoices', url: `/organizations/${org_identifier}/invoices` }]} />
            {
              invoiceData?.invoice_status === 'pending' ? (
                <PendingInvoice
                  current_user={current_user}
                  data={invoiceData}
                  invoiceId={invoiceId}
                  organization_name={org_identifier}
                  setToggle={setToggle}
                  setLoading={setLoading}
                  razorpayKey={razorpayKey} />) :
                (<PaidInvoice
                  invoiceData={invoiceData}
                  organization_name={org_identifier}
                  invoiceId={invoiceId}
                  loading={loading}
                />)

            }
          </SpinnerLoader>
        </SuperUserContext>
      </div>
    </>
  )
}
